<template>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header p-2">
                    <h5 class="modal-title">Retrieve As</h5>
                    <button class="close text-white" data-dismiss="modal" aria-label="Close" @click="closeDialog()">
                        <span aria-hidden="true">
                            <cancel-icon class="close-icon" style="height: 30px !important;width: 30px !important;color: #fff;"></cancel-icon>
                        </span>
                    </button>
                </div>
                <div class="modal-body" :style="isUserActionEnabled('Transcode')?'height:347px':'height:340px'">
                    <div class="h-100" style="overflow:auto" ref="generalTab">
                        <div class="common-input-field" style="margin-inline-start: 2%;margin-top:7px;">
                            <div>
                            <label>Media slug</label>
                            </div>
                            <input v-model="slugName" :title="slugName" ref="dst_file_name_ref" type="text"  class="bg-transparent rounded text-light input-text-field add-border"/>
                        </div>

                        <div v-if="isUserActionEnabled('Transcode')" class="common-input-field" style="margin-inline-start: 2%;margin-top:8px;align-items: center;">
                            <label>Profile</label>
                            <div class="search-bar-comm-style" style="display: block;flex:1;">
                                <Multiselect
                                    v-model="profileObj"
                                    :options="profilesList"
                                    label="profile_name"
                                    placeholder="Select Profile"
                                    :hideSelected="false"
                                    :close-on-select="true"
                                    deselectLabel=""
                                    selectLabel=""
                                    selectedLabel=""
                                    :showNoOptions="false"
                                    @open="dropDownOpened"
                                    @select="selectProfile($event)"
                                    ref="profilesDropdown"
                                    >
                                    <span slot="noResult">No results.</span>
                                </Multiselect>
                            </div>
                        </div>
                        <div class="common-input-field" style="margin-inline-start: 2%;margin-top:7px;">
                            <label>Path</label>
                            <div style="flex: 1;display: flex; flex-direction: column; justify-content: center;">
                                <div style="display: inline-flex;">
                                    <span v-if="!dstPath" class="ml-0 mr-2" style="border:1px solid #4a4a4a;color: #4f4f4f; margin-inline-start: 0px !important;width: 100%;
                                        padding: 8px 8px;
                                        border-radius: 5px;
                                        margin-bottom: 3px;">NONE</span>
                                    <span v-else class="ml-4 mr-2" style="border:1px solid #4a4a4a;color: #f8f9fa; margin-inline-start: 0px !important;width: 100%;padding: 8px 8px;
                                        border-radius: 5px;
                                        margin-bottom: 3px;
                                        overflow-wrap: anywhere;">{{dstPath.replace("share://","")}}</span>
                                    <browse-icon v-on:click="isActiveBinBrowse = true" style="height:26px;margin-inline-start:3px;position: relative;bottom: -4px;cursor:pointer;"></browse-icon>
                                </div>
                            </div>
                        </div>
                        <!-- v-if="fcpxmlExport != 'fcpxml_export'" -->
                        <div v-if="isUserActionEnabled('Transcode') && profileObj"  class="common-input-field" :class="{readonlyDiv:Object.keys(globalSettingsFromStartup).includes('CATALOG_READ_ONLY') && globalSettingsFromStartup.CATALOG_READ_ONLY}" style="margin-inline-start: 2%;margin-top:8px;">
                            <label>Catalog
                                <span class="readonly-field ml-1" v-if="Object.keys(globalSettingsFromStartup).includes('CATALOG_READ_ONLY') && globalSettingsFromStartup.CATALOG_READ_ONLY">
                                    ( non editable )
                                </span>
                            </label>
                            <div style="flex: 1;display: flex; flex-direction: column; justify-content: center;">
                                <div class="search-bar-comm-style catalog-dropdown" style="display: inline-flex;">
                                <catalog-dropdown ref="catalogDropdownInput" 
                                :selectedOptions="selectedCatalogsArr" 
                                :enableCatBrowser="Object.keys(globalSettingsFromStartup).includes('CATALOG_READ_ONLY') && globalSettingsFromStartup.CATALOG_READ_ONLY?false:true" style="width:100%;margin-inline-end: 6px;"
                                :allowSingleSelect="!(globalSettingsFromStartup && globalSettingsFromStartup.enable_multi_catalog_browse)"
                                :allowSingleSelectFromBrowse="!(globalSettingsFromStartup && globalSettingsFromStartup.enable_multi_catalog_browse)"
                                from="TagMetadata"></catalog-dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer p-0 primary-btn-style">
                    <button class="btn btn-outline-secondary mr-2" data-dismiss="modal" @click.prevent="closeDialog()">Cancel</button>
                    <button class="btn btn-outline-primary mr-3" @click.prevent="submitRetrieve()">Retrieve</button>
                </div>
            </div>
        </div>
        <FolderBrowseModel ref="foldersBrowseModal"
            v-if="isActiveBinBrowse"
            :workspaceList="folderWorkspaceList"
            :enableAssetMultiSelect="false"
            @close="isActiveBinBrowse = false"
            @handleFilesBrowse="refreshBrowsedFolder"
            :enableRecursive="false"
            :browseOnlyFolders="true"
            style="z-index:99">
        </FolderBrowseModel>
    </div>
</template>
    
<script>
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import Constants from "../../components.constants.js";
    import {NotifierConstants} from "../../components.constants.js";
    import Multiselect from "vue-multiselect";
    import Utils from '../../components.utils';
    import cancelIcon from "../core/InlineCancelField.vue";
    import browseIcon from "./InlineBrowseField.vue";
    import FolderBrowseModel from "../files/filesBrowse.vue";
    import CatalogDropdown from "../categories/CatalogMultiselectDropdown.vue";
    
    export default {
        props:["fileInfo"],
        components:{
            "browse-icon" : browseIcon,
            Multiselect,
            FolderBrowseModel,
            'cancel-icon':cancelIcon,
            "catalog-dropdown":CatalogDropdown,
        },
        data: () => ({
            folderWorkspaceList:[Constants.WORKSPACE_BINS],
            dialog: true,
            slugName:"",
            dstPath:"",
            profileObj:null,
            profilesList:[],
            isActiveBinBrowse:false,
            selectedCatalogsArr:null,
        }),
        methods:{
            refreshBrowsedFolder(folderInfoList){
                if(folderInfoList && folderInfoList.length > 0){
                    this.dstPath = folderInfoList[0].path
                    Utils.setLocalStorageValue('retrieve-as-path',this.dstPath);
                }else{
                    console.log("Failed to update the browsed folder path:",folderInfoList)
                }
                this.isActiveBinBrowse = false
            },
            dropDownOpened(){
                this.$refs.profilesDropdown.$el.querySelector('.multiselect__content-wrapper').style.setProperty('width',`${this.$refs.generalTab.offsetWidth - 40}px`,'important'); 
            },
            closeDialog(){
                this.profileObj = null;
                this.$emit("close")
            },
            submitRetrieve(){
                if(this.slugName.trim().length <= 0){
                    alert("Please add valid 'Media Slug'");
                    return false;
                }
                if(this.slugName.includes(",")){
                    alert("Slug name with commma(,) is not allowed");
                    return false;
                }
                if(this.dstPath.trim().length <= 0){
                    alert("Please add valid 'Path'");
                    return false;
                }

                let payload ={file_uid: this.fileInfo.file_uid,
                                element_type:'file',
                                in_outs:{"mark_in":-1, "mark_out":-1},
                                dst_file_name: this.slugName,
                                dst_folder:this.dstPath,
                                path:this.fileInfo.path,
                            }
                if(this.isUserActionEnabled('Transcode') && this.profileObj && Object.hasOwnProperty.call(this.profileObj,'_id')){
                    payload['profile_id'] = this.profileObj._id;
                    payload['job_name'] = 'Transcode';
                }else{
                    payload['job_name'] = 'Retrieve';
                }

                if(this.$refs.catalogDropdownInput && this.$refs.catalogDropdownInput.getSelectedCatalogId()){
                    console.log("selected catalog id for retrieve as....", this.$refs.catalogDropdownInput.getSelectedCatalogId());
                    let parentIdPath = {};
                    parentIdPath["parent_id_path"] = this.$refs.catalogDropdownInput.getSelectedCatalogId();
                    payload["assigned_metadata"] = parentIdPath;
                }
                
                this.createNewJob(payload).then((data)=>{
                    if (data.statusCode==200){
                        this.$toast.success(data.message);
                    }else{
                        this.$toast.error(data.message);
                    }
                    this.closeDialog()
                })                
            },
            isUserActionEnabled(priv){
                return (Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege,priv) && this.fileInfo.mime_type && this.fileInfo.mime_type.startsWith('video'))
            },
            selectProfile(selectedProfile){
                Utils.setLocalStorageValue('retrieve-as-profile',JSON.stringify(selectedProfile));
            },
            reloadDstPath(){
                if(Utils.getLocalStorageValue('retrieve-as-path') != null){
                    this.dstPath = Utils.getLocalStorageValue('retrieve-as-path');
                }else if(this.startupData && 'user_preferred_retrieve_path' in this.startupData){
                    this.dstPath = this.startupData['user_preferred_retrieve_path']
                }
            },
            handlePreferredRetrievePathNotification(notification){
                notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
                let socketMessage = notification.message
                if(socketMessage){
                    setTimeout(()=>{
                    this.reloadDstPath();
                    }, 200)
                }
            },
            registerWebsocketNotifier(){
                this.addWSEventListener({eventname:[NotifierConstants.userGroupModifiedNotification, NotifierConstants.userModifiedNotification, NotifierConstants.retreiveSettingsNotification],
                    callback:this.handlePreferredRetrievePathNotification,parent:"RetrieveAs"})
            },
            unRegisterWebsocketNotifier(){
                this.removeEventListener({eventname:[NotifierConstants.userGroupModifiedNotification, NotifierConstants.userModifiedNotification, NotifierConstants.retreiveSettingsNotification],
                    callback:this.handlePreferredRetrievePathNotification,parent:"RetrieveAs"})
            },
            ...mapActions("categories", ["updateExistingCategory"]),
            ...mapActions('transcoder',['getConfiguredTranscoderProfilesFromServer']),
            ...mapActions('jobs',["createNewJob"]),
            ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
        },
        created(){
            console.log("load retrieve as :::::::::::::::::::::::::::::")
            if(this.isUserActionEnabled('Transcode')){
                this.getConfiguredTranscoderProfilesFromServer().then(data => {
                    this.profilesList = data.profiles;
                });
            }
            this.reloadDstPath();
            if(Utils.getLocalStorageValue('retrieve-as-profile') != null){
                this.profileObj = JSON.parse(Utils.getLocalStorageValue('retrieve-as-profile'));
            }
            this.slugName = this.fileInfo.slug_name
            this.registerWebsocketNotifier();
        },
        mounted(){
            //document.getElementById("field-edit-slug").focus(); // "field-edit-slug" this ID is not given so commenting
            this.$refs["dst_file_name_ref"].focus();
        },
        computed: {
            startupData:{
                get(){
                    return this.$store.state.startUpData.startUpDataDetails;
                }
            },
            ...mapGetters("users",["getLoggedInUserPrivilege"]),
            globalSettingsFromStartup:{
                get(){
                return this.$store.state.startUpData.startUpDataDetails;
                },
            },
        },
        beforeDestroy(){
            this.unRegisterWebsocketNotifier()
        }
    }
</script>
    
<style lang="scss" scoped>
    $table-row-border: none;
    $active-blue: #007bff;
    $danger-color: #dc3545;
    $none-text-color:#4f4f4f;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $add-button-backgroud:#1e1e1e;
    $active-green-color:#28a745;
    $primary-background: #1a1e21;
    $border-color: 1px solid #4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $highlight-font-color:#ff9800;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555; 
    $input-field-padding:.375rem 10px;
    $filter-border-color: #5a5a5a;
    $filter-bg-color: #2a2a2a;
    $learn-about-text-color-hover:#b7b327;
    $learn-about-text-color:#9a9620;
    $tags-background-color:#282d31;
    $svg-color:#666;
    $tags-border-color:#363636;
    $secondary-border-color: 1px solid #2b2b2b;
    $icon-hover:#2c3339;
    $readOnly-bg-color: #1e2326 !important;

    .modal-dialog {
        max-width: 470px;
        width: 470px;
        height: 560px;
        margin: 0;
        padding: 0;
    }
      
    .modal-content {
        height: auto;
        min-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        background: $primary-background !important;
        border: $secondary-border-color;
        .modal-body{
            background: $primary-background;
            height: 300px;
            user-select: text !important; 
            padding: 1rem;
        }
    }
    
    .modal {
        text-align: center;
        padding: 0!important;
        display:block;
        position: fixed;
        inset-inline-start: 0px;
        top: 2%;
    }
    .modal-header .close {
        // margin: -1rem -13px -1rem auto !important;
        margin:0px !important;
        padding: 0px !important;
    }
    .modal:before {
        content: '';
        display: inline-block;
        height: 100%;
        vertical-align: middle;
        margin-inline-end: -4px;
        position: fixed;
        width: 100vw;
        inset-inline-start: 0;
        top: 0;
        background: #00000094;
    }
    .modal-dialog {
        display: inline-block;
        text-align: start;
        vertical-align: middle;
    }

    .input-text-field{
        height: 44px;
        width: 100% !important;
        padding-inline-start: 2%;
        padding-inline-end:2%;
        overflow: hidden;
        border: $border-color;
    }
    
    .btn{
        font-size:14px !important;
        height:100%;
    }
    
    .border{
        border: $border-color !important;
    }
    
    .modal-header,.modal-footer{
        border-top: $secondary-border-color !important;
        border-bottom: $secondary-border-color !important;
        background: $secondary-background-color;
        .modal-title{
            color:$text-color;
        }
    }
    .modal-footer{
        padding: 5px 0px !important;
    }
    
    .modal-header{
      align-items:center;
      padding: 16px 24px 10px !important;
    }
    
    .modal-header .close {
        // margin: -1rem -13px -1rem auto !important;
        margin:0px !important;
        padding: 0px !important;
    }
    
    .primary-btn-style{
        margin-top:1%;
        button{
            height: 35px;
            width: 70px;
            font-size:14px;
        }
    }
    
    .secondary-btn-style{
      color:$text-color;
    }

    .common-input-field{
        margin-inline-start: 3%;
        display: inline-block;
        width: 96%;
        justify-content: space-between;
        display: inline-block;
        padding: 9px;
        border-radius: 4px;
        background: $primary-background;
        border: $secondary-border-color !important;
        label{
            width: 30%;
            color: $secondary-text-color;
            word-break: break-word;
        }
        input{
            flex:1;
        }
    }

    .input-labels {
        width: 101px;
        align-items: center;
        display: flex;
        color: #9b9a9a;
    }
    
    .input-fields {
      border: none !important;
      border-bottom: 1px solid $active-blue !important;
      height:30px;
      text-overflow: ellipsis;
    }
    
    .input-fields:focus {
      outline: unset;
      box-shadow:none;
    }
    .close-icon:hover{
      background: $icon-hover;
      border-radius: 20px;
    }
    .config-desc{
      color: $dull-text-color;
      font-size:12px;
    }

     /* width */
    ::-webkit-scrollbar {
        width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $scrollbar-thumb-on-hover-background;
    }
    
    ::v-deep{
        .readonlyDiv{
            background: $readOnly-bg-color;
            pointer-events: none;
            border:none !important;
            label{
                width: 45%
            }
            .multiselect__tags{
                border: none !important;
                background: transparent !important;
            }
        }
        .multiselect{
            width:100%;
            margin: 3px 0px;
            display: flex;
        }
        .multiselect__content-wrapper{
            display:none;
        }
        .tags-style{
            margin:5px;
        }
        .multiselect__tag, .tags-style {
            background-color: $primary-background !important;
            border: $border-color;
            border-radius: 5px;
            margin-bottom:0px;
        }
        .multiselect__tags, .tags-style {
            background: $primary-background !important;
            border: $border-color !important;
        }
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
            color:$text-color;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
            color:$secondary-text-color !important;
            font-size: 20px;
        }
        .multiselect *{
            font-size: $input-field-and-label-font-size;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__tags{
            display: block;
            align-items: center;
            width: 100%;
            height: 44px !important;
            padding: 5px 40px 0 8px!important;
            .selected-tags-style{
                margin : 0px !important;
            }
        }
        .multiselect__placeholder {
            padding-top: 5px !important;
            margin-bottom:0px;
            color:$dull-text-color !important;
        }
        .multiselect{
            color:$text-color !important;
            font-size: $input-field-and-label-font-size !important;
            min-height: 38px;
            height:auto !important;
        }
        .multiselect__single{
            padding-top:6px !important;
        }
        .multiselect__option--selected{
            background: $bg-color-on-hover !important;
            color: $text-color;
        }
        .multiselect__content-wrapper{
            border: 1px solid $bg-color-on-hover !important;
            position: absolute;
            display: block;
            background: $text-color;
            width: 100%;
            max-height: 150px;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
            background: $secondary-background-color !important;
        }
        .multiselect__tags {
            background: $primary-background!important;
            height: auto;
        }
        .filter-wrapper{
            display:inline-flex;
            align-items: center;
            border: $border-color;
            border-radius: 5px;
            background: $primary-background;
            color:$dull-text-color;
            .filter-label{
                margin:0px 4px;
                width: auto;
                white-space: nowrap;
            }
            .comm-input-field-style,.multiselect__tags{
                border: none !important;
                border-radius: none !important;
            }
            .mx-input{
                height:38px;
            }
            .multiselect{
                margin:0px !important;
            }
        }

        .catalog-dropdown {
            .multiselect__content-wrapper{
                top:45px !important;
            }

            .multiselect__tags{
                height: auto !important;
            }
        }
    }
</style>